export type NotificationCategory =
  | 'appointment'
  | 'order'
  | 'lab'
  | 'radiology'
  | 'pharmacy'
  | 'system'
  | 'test'
  | 'intake'
  | 'encounter'

export type NotificationAudience = 'staff' | 'patient'

export type AppNotification = {
  id: string
  category: NotificationCategory
  title: string
  body: string
  actionUrl?: string | null
  audience: NotificationAudience
  readAt: string | null
  createdAt: string
  unread: boolean
  notifiableType?: string | null
  notifiableId?: string | null
}

export const CATEGORY_LABELS: Record<NotificationCategory, string> = {
  appointment: 'Appointment',
  order: 'Order',
  lab: 'Lab',
  radiology: 'Radiology',
  pharmacy: 'Pharmacy',
  system: 'System',
  test: 'Test',
  intake: 'Intake',
  encounter: 'Encounter'
}
